// @flow
import axios from 'lib/defaultClient';

export const like = (letterId: string) => axios.post(`/letters/${letterId}/like`);

export const unlike = (letterId: string) => axios.delete(`/letters/${letterId}/like`);

export const getLikesCount = (letterId: string) => axios.get(`/letters/${letterId}/like`);



// WEBPACK FOOTER //
// ./src/lib/api/letters/like.js